import './leasing-details.scss';

import type { TLeasingOrderResponse } from '@/components/App/Leasing/types';
import { CircledImage, Modal } from '@/components/Shared/ui';

type TProps = {
  isModalOpen: boolean;
  leasingOffer: TLeasingOrderResponse;
  onClose: () => void;
};

const LeasingDetails: React.FC<TProps> = ({
  isModalOpen,
  leasingOffer,
  onClose
}) => {
  if (!leasingOffer.comment) return null;
  return (
    <Modal
      centered
      className="ie-details"
      title={
        <div className="ie-details__title-wrapper">
          <h3 className="ie-details__title">Описание решения</h3>
          <div className="ie-details__title-leasing-company">
            <CircledImage
              src={leasingOffer.leasingCompany.icon}
              alt={leasingOffer.leasingCompany.name}
              size={40}
            />
            {leasingOffer.leasingCompany.name}
          </div>
        </div>
      }
      open={isModalOpen}
      onClose={onClose}
      footer={<></>}
      width={800}
      destroyOnHidden
      mask={{ closable: true }}
    >
      <p className="ie-details__comment">{leasingOffer.comment}</p>
    </Modal>
  );
};

export default LeasingDetails;
